import { FULL_NAME_SEPARATOR } from '../../../funnel-map-canvas/helper';
import type {
  FilterItem,
  FilterToggleItem,
  FilterValues,
} from '../../../common/filters/filters-renderer/types';
import { DocumentationFiltersTypesMap } from './filterTypes';
export const getStepFullNameFromId = (id: string) => id.split(FULL_NAME_SEPARATOR)?.[2];
export const getParentFromStepId = (id: string) => id.split(FULL_NAME_SEPARATOR)?.[0];

export const updateStructureWithParentElementType = (
  parentType: string,
  objectName: string,
  items?: AutomationStructureNew[],
) =>
  items
    ?.map((item) => ({ ...item, parentType }))
    .filter((item) => item.objectName === objectName) ?? [];

export const getOnlyAutomationsOfObject = (automations: AutomationStructureNew[], objectName: string) =>
  automations?.filter((automation) => automation.objectName !== objectName);

export const checkFiltersHaveValuesCb = (
  filters: { [key: string]: FilterItem | FilterToggleItem },
  filterValues: FilterValues,
): boolean => {
  const withOutActiveState = Object.entries(filterValues).filter(
    ([key]) => key !== DocumentationFiltersTypesMap.activeState,
  );

  return withOutActiveState.some(([, filterValue]) => filterValue.selectedValues.length > 0);
};
